import {
  GET_TEMPLATE_INFO_START,
  GET_TEMPLATE_INFO_SUCCESS,
  GET_TEMPLATE_INFO_FAIL,
  GET_TEMPLATES_START,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL,
  CREATE_TEMPLATE_SUCCESS,
  CREATE_TEMPLATE_START,
  CREATE_TEMPLATE_FAIL,
  ARCHIVE_TEMPLATE_SUCCESS,
  ARCHIVE_TEMPLATE_FAIL,
  ARCHIVE_TEMPLATE_START,
  ACTIVATE_TEMPLATE_START,
  ACTIVATE_TEMPLATE_SUCCESS,
  ACTIVATE_TEMPLATE_FAIL,
  UPDATE_TEMPLATE_START,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAIL,
  DELETE_TEMPLATE_START,
  DELETE_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE_FAIL,
  GET_TIME_BOUNDS_SUCCESS,
  GET_TIME_BOUNDS_START,
  GET_TIME_BOUNDS_FAIL,
  GET_GROUPED_TEMPLATES_START,
  GET_GROUPED_TEMPLATES_SUCCESS,
  GET_GROUPED_TEMPLATES_FAIL,
  GET_MAILING_TRIGGERS_FAIL,
  GET_MAILING_TRIGGERS_SUCCESS,
  GET_MAILING_TRIGGERS_START,
  GET_BONUS_CARD_MAILING_TEMPLATES_START,
  GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS,
  GET_BONUS_CARD_MAILING_TEMPLATES_FAIL,
  CREATE_MAILING_FOR_BONUS_CARD_START,
  CREATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  CREATE_MAILING_FOR_BONUS_CARD_FAIL,
  UPDATE_MAILING_FOR_BONUS_CARD_START,
  UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  UPDATE_MAILING_FOR_BONUS_CARD_FAIL,
  DELETE_MAILING_FOR_BONUS_CARD_START,
  DELETE_MAILING_FOR_BONUS_CARD_SUCCESS,
  DELETE_MAILING_FOR_BONUS_CARD_FAIL,
} from './constants';
import {
  requestDeleteTemplate,
  requestGetTemplateList,
  requestUpdateTemplate,
  requestChangeTemplateStatus,
  requestCreateTemplate,
  requestGetTemplate,
  requestGetTimeBounds,
  requestGetMailingTriggers,
  requestGetGroupedTemplateList,
  requestBonusCardMailingTemplates,
  requestCreateMailingForBonusCard,
  requestUpdateMailingForBonusCard,
  requestDeleteMailingForBonusCard
} from '../../api/mailing';
import { action } from '../action';

const getErrorDetails = (error) => {
  return error.detail || error.response?.data?.detail || error.toString();
};

export const actionTemplate = action(
  GET_TEMPLATE_INFO_START,
  GET_TEMPLATE_INFO_SUCCESS,
  GET_TEMPLATE_INFO_FAIL
);
export const getTemplateById = (id) => async (dispatch) => {
  try {
    dispatch(actionTemplate.start());
    const data = await requestGetTemplate(id);
    dispatch(actionTemplate.success(data));
  } catch (error) {
    dispatch(actionTemplate.fail(error.detail));
  }
};

export const actionTemplates = action(
  GET_TEMPLATES_START,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL
);
export const getMailingTemplates = (payload) => async (dispatch) => {
  try {
    dispatch(actionTemplates.start());
    const data = await requestGetTemplateList(payload);
    dispatch(actionTemplates.success(data));
  } catch (error) {
    dispatch(actionTemplates.fail(error.detail));
  }
};

export const actionGroupedTemplates = action(
  GET_GROUPED_TEMPLATES_START,
  GET_GROUPED_TEMPLATES_SUCCESS,
  GET_GROUPED_TEMPLATES_FAIL
);
export const getGroupedTemplates = () => async (dispatch) => {
  try {
    dispatch(actionGroupedTemplates.start());
    const data = await requestGetGroupedTemplateList();
    dispatch(actionGroupedTemplates.success(data));
  } catch (error) {
    dispatch(actionGroupedTemplates.fail(error.detail));
  }
};

export const actionBonusCardMailingTemplates  = action(
  GET_BONUS_CARD_MAILING_TEMPLATES_START,
  GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS,
  GET_BONUS_CARD_MAILING_TEMPLATES_FAIL,
);
export const getBonusCardMailingTemplates = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionBonusCardMailingTemplates.start());
    const data = await requestBonusCardMailingTemplates(id, payload);
    dispatch(actionBonusCardMailingTemplates.success(data));
  } catch (error) {
    dispatch(actionBonusCardMailingTemplates.fail(error.detail));
  }
}

export const actionArchiveTemplate = action(
  ARCHIVE_TEMPLATE_START,
  ARCHIVE_TEMPLATE_SUCCESS,
  ARCHIVE_TEMPLATE_FAIL,
);
export const archiveTemplate = (id) => async (dispatch) => {
  try {
    dispatch(actionArchiveTemplate.start());
    const data = await requestChangeTemplateStatus(id, { status: 'archive' });
    dispatch(actionArchiveTemplate.success({ ...data, id }));
  } catch (error) {
    dispatch(actionArchiveTemplate.fail(getErrorDetails(error)));
  }
};
export const clearArchiveTemplateErrors = () => async (dispatch) => {
  dispatch(actionArchiveTemplate.fail(null));
};

export const actionActivateTemplate = action(
  ACTIVATE_TEMPLATE_START,
  ACTIVATE_TEMPLATE_SUCCESS,
  ACTIVATE_TEMPLATE_FAIL,
);
export const activateTemplate = (id) => async (dispatch) => {
  try {
    dispatch(actionActivateTemplate.start());
    const data = await requestChangeTemplateStatus(id, { status: 'created' });
    dispatch(actionActivateTemplate.success({ ...data, id }));
  } catch (error) {
    dispatch(actionActivateTemplate.fail(error.detail));
  }
};

export const actionDeleteTemplate = action(
  DELETE_TEMPLATE_START,
  DELETE_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE_FAIL,
);
export const deleteTemplate = (id, redirectToTemplates) => async (dispatch) => {
  try {
    dispatch(actionDeleteTemplate.start());
    const data = await requestDeleteTemplate(id);
    dispatch(actionDeleteTemplate.success({ ...data, id }));
    redirectToTemplates && redirectToTemplates();
  } catch (error) {
    dispatch(actionDeleteTemplate.fail(error.detail));
  }
};

export const actionTimeBounds = action(
  GET_TIME_BOUNDS_START,
  GET_TIME_BOUNDS_SUCCESS,
  GET_TIME_BOUNDS_FAIL
);
export const getTimeBounds = () => async (dispatch) => {
  try {
    dispatch(actionTimeBounds.start());
    const data = await requestGetTimeBounds();
    dispatch(actionTimeBounds.success(data));
  } catch (error) {
    dispatch(actionTimeBounds.fail(error.detail));
  }
};

export const actionTriggers = action(
  GET_MAILING_TRIGGERS_START,
  GET_MAILING_TRIGGERS_SUCCESS,
  GET_MAILING_TRIGGERS_FAIL
);
export const getMailingTriggers = () => async (dispatch) => {
  try {
    dispatch(actionTriggers.start());
    const data = await requestGetMailingTriggers();
    dispatch(actionTriggers.success(data));
  } catch (error) {
    dispatch(actionTriggers.fail(error.detail));
  }
};

export const actionCreateTemplate  = action(
  CREATE_TEMPLATE_START,
  CREATE_TEMPLATE_SUCCESS,
  CREATE_TEMPLATE_FAIL
);
export const createTemplate = (payload, redirectToMailing) => async (dispatch) => {
  try {
    dispatch(actionCreateTemplate.start());
    const data = await requestCreateTemplate(payload);
    dispatch(actionCreateTemplate.success(data));
    redirectToMailing && redirectToMailing();
  } catch (error) {
    dispatch(actionCreateTemplate.fail(getErrorDetails(error)));
  }
};

export const actionUpdateTemplate  = action(
  UPDATE_TEMPLATE_START,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAIL
);
export const updateTemplate = (id, payload, redirectToMailing) => async (dispatch) => {
  try {
    dispatch(actionUpdateTemplate.start());
    const data = await requestUpdateTemplate(id, payload);
    dispatch(actionUpdateTemplate.success(data));
    redirectToMailing && redirectToMailing();
  } catch (error) {
    dispatch(actionUpdateTemplate.fail(getErrorDetails(error)));
  }
};

export const actionsCreateMailingForBonusCard = action(
  CREATE_MAILING_FOR_BONUS_CARD_START,
  CREATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  CREATE_MAILING_FOR_BONUS_CARD_FAIL,
);
export const createMailingForBonusCard = (id, payload, isActive, redirect) => async (dispatch) => {
  try {
    dispatch(actionsCreateMailingForBonusCard.start());
    const data = await requestCreateMailingForBonusCard(id, payload, isActive);
    dispatch(actionsCreateMailingForBonusCard.success(data));
    redirect && redirect();
  }
  catch (error) {
    dispatch(actionsCreateMailingForBonusCard.fail(getErrorDetails(error)));
  }
};

export const actionsUpdateMailingForBonusCard = action(
  UPDATE_MAILING_FOR_BONUS_CARD_START,
  UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  UPDATE_MAILING_FOR_BONUS_CARD_FAIL,
);
export const updateMailingForBonusCard = (id, mailingId, payload, changedMailing) => async (dispatch) => {
  try {
    dispatch(actionsUpdateMailingForBonusCard.start());
    await requestUpdateMailingForBonusCard(id, mailingId, payload);
    dispatch(actionsUpdateMailingForBonusCard.success(changedMailing));
  } catch (error) {
    dispatch(actionsUpdateMailingForBonusCard.fail(getErrorDetails(error)));
  }
};

export const actionsDeleteMailingForBonusCard = action(
  DELETE_MAILING_FOR_BONUS_CARD_START,
  DELETE_MAILING_FOR_BONUS_CARD_SUCCESS,
  DELETE_MAILING_FOR_BONUS_CARD_FAIL,
);
export const deleteMailingForBonusCard = (id, mailingId, isActive = false) => async (dispatch) => {
  try {
    dispatch(actionsDeleteMailingForBonusCard.start());
    const data = await requestDeleteMailingForBonusCard(id, mailingId, isActive);
    dispatch(actionsDeleteMailingForBonusCard.success(data));
  } catch (error) {
    dispatch(actionsDeleteMailingForBonusCard.fail(getErrorDetails(error)));
  }
};
